import * as React from "react";
const SvgIcSidebarFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8 20H1V4H8L8 20ZM10 20H23V4H10L10 20Z" fill="currentColor" /></svg>;
export default SvgIcSidebarFilled;